module.exports = __webpack_public_path__ + "assets/cdf37f1e3efafda7c27d4bdb2dc64e49.json";